<template>
    <div>
            <b-toast
		id="toast-check-report-student"
		variant="none"
		no-close-button
		toaster="b-toaster-top-center"
		>
		<img
			src="@/assets/img/ico-check.png"
			style="margin-right: 10px; margin-top: -2px"
		/>
		{{ message }}
		</b-toast>
		<b-toast
		id="toast-equis-report-student"
		variant="none"
		no-close-button
		toaster="b-toaster-top-center"
		>
		<img
			src="@/assets/img/ico-equis.png"
			style="margin-right: 10px; margin-top: -2px"
		/>
		{{ message }}
		</b-toast>
        <b-breadcrumb>
            <b-breadcrumb-item to="/teacher/student">My Students</b-breadcrumb-item>
            <b-breadcrumb-item active> <span v-if="dataStudent">{{dataStudent.name}}: </span> 
                <span>Student Reports</span>
            </b-breadcrumb-item>
        </b-breadcrumb>
        <div class="card" style="margin-bottom:22px;">
            <div class="card-body">
                <div class="d-flex align-items-center justify-content-between" style="margin-bottom: 32px;">
                    <div class="back-step mt-0"  @click="backStep">
                        <img class="svg" src="@/assets/icons/icon-arrow-left.svg">{{$t('planesYPrecios.regresar')}}
                    </div>
                    <h4 class="sub-title d-flex mb-0" style="padding-right: 20px;">
                        <span>Report:</span>
                        <p class="mb-0" style="font-weight: 400;margin-left: 6px;" v-if="dataStudent">{{dataStudent.date}}</p>
                    </h4>
                     
                    <div class="d-flex align-items"  >
                        <a v-if="idParam"  class="link blue"  :class="{ loading: isLoadingDow }"  @click="downloadFile"><span>{{$t('evaluations-reports.text.2')}}</span></a>
                        <img v-if="idParam"  src="@/assets/icons/icon-arrow-download.svg" class="svg">
                    </div>
                 
                </div>
                <b-row class="evaluationCourse mb-0">
                    <b-col class="justify-content-center">
                        <div class="sub-title-img name">
                            <b-avatar
                            variant="light"
                            :src="urlPhoto"
                            ></b-avatar>
                            <div>
                                <span class="blue">Student:</span>
                                <span v-if="dataStudent">
                                    <p>{{dataStudent.name}}</p>
                                    <p>{{dataStudent.flag ? `(${dataStudent.groupsCode})`: ''}}</p>
                                </span>
                               
                            </div>
                        </div>
                    </b-col>
                    <b-col class="justify-content-center">
                        <div class="sub-title-img name">
                            <img src="@/assets/img/progress-small.png">
                            <div>
                                <span class="blue">Courses:</span>
                                <span v-if="dataStudent"><p  v-for="(item ,index) in dataStudent.subjectsStr" :key="index">{{item}}</p></span>
                                 
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </div>
        </div>
        <div class="card" id="reportCourse">
            <div class="card-body">
                <div class="container-courses" v-for="(item,index) in $v.dataCourses.$each.$iter " :key="`courses-${index}`">
              
                    <h4 class="sub-title d-flex mb-0 justify-content-center" style="padding-right: 20px;">
                        <span>Course:</span>
                        <p class="mb-0" style="font-weight: 400;margin-left: 6px;">{{item.subjectName.$model}}</p>
                    </h4>
                   
                    <div class="section_gray text" style="margin-top: 27px;margin-bottom:30px;">
                        <div class="d-flex align-items-center ">
                            <h6 class="bold m-0" style="font-size: 15px;">Comments:</h6>
                            <b-button style="    background: none;border: none;display: contents;"  v-if="flagTeacherReport && $route.params.id>0 &&  !item.flagEdit.$model" :disabled="item.comment.$invalid">
                                 <b-badge :disabled="item.comment.$invalid"  pill variant="primary" @click="saveReport(item)"   :class="{ loading: isLoading }" class="btn btn-primary ml-3">
                                Save
                            </b-badge>
                            </b-button>
                       
                                      <b-badge v-if="flagTeacherReport && item.flagEdit.$model" pill variant="primary" @click="item.flagEdit.$model = !item.flagEdit.$model" class="btn btn-primary ml-3">
                                Edit comment 
                            </b-badge>
                     
                           
                          
                        </div>
                        
                        <b-form-group class="my-4 ">
            
                                <p class="mb-0" v-if="item.flagEdit.$model">
                                    {{item.comment.$model}}
                                </p>

                                <b-form-textarea v-else
                                    style="font-size:13px;max-height: 205px;"
                                    v-model="item.comment.$model"
                                     :class="{ 'error-input': item.comment.$error }"
                                    no-resize
                                    rows="4"
                                    placeholder="You must enter your comments to create the report."
                                
                                    >
                                </b-form-textarea>
                                 <div class="error-label">{{ validationMsg(item.comment) }}</div>
    
                        </b-form-group>
                     
                    </div>
                     <h6 class="bold" style="font-size: 15px;">Evaluations:</h6>
                    <b-list-group class="description-list">
                        <b-list-group-item>
                            <b-form-row>
                                <b-col cols="2"><h6 class="bold">Date Submitted</h6></b-col>
                                <b-col cols="1"><h6 class="bold">Module</h6></b-col>
                                <b-col cols="1"><h6 class="bold">Score</h6></b-col>
                                <b-col cols="8" style="padding-right: 30px;"><h6 class="bold">Comments</h6></b-col>
                            </b-form-row>
                        </b-list-group-item>
                        <b-list-group-item class="table-file">
                            <b-form-row v-if="item.listEvaluations.$model.length==0">
                                <span style=" width: 100%;">There are no records of evaluations.</span> 
                            </b-form-row>
                            <span v-else>
                                   <b-form-row v-for="(itemEval,index) in item.listEvaluations.$model" :key="`evaluations-${index}`">
                                <b-col cols="2"><p>{{itemEval.strSubmittedDateHourShort_EN}}</p></b-col>
                                <b-col cols="1"><p>{{itemEval.module}}</p></b-col>
                                <b-col cols="1"><p>{{itemEval.strScore}}</p></b-col>
                                <b-col cols="8" class="comments d-flex justify-content-between" style="padding-right: 30px;">
                                    <v-clamp autoresize :max-lines="1">
                                        {{itemEval.teacherComments}}
                                      
                                    </v-clamp>
                                       <span class="link blue view-more" @click="directionView(1,itemEval)">{{ 'View more' }}</span>
                                    <!-- <p>
                                        Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam
                                        nonummy nibh euismod tincidunt ut laoreet dolore...
                                    </p>
                                    <a class="link blue"><span>Download report</span></a> -->
                                </b-col>
                            </b-form-row>
                            </span>
                         
                        </b-list-group-item>
                    </b-list-group>
                    <h6 class="bold" style="font-size: 15px;">Assignments:</h6>
                    <b-list-group class="description-list">
                        <b-list-group-item>
                            <b-form-row>
                                <b-col cols="2"><h6 class="bold">Date Submitted</h6></b-col>
                                <b-col cols="1"><h6 class="bold">Module</h6></b-col>
                                <b-col cols="1"><h6 class="bold">Score</h6></b-col>
                                <b-col cols="8" style="padding-right: 30px;"><h6 class="bold">Comments</h6></b-col>
                            </b-form-row>
                        </b-list-group-item >
                        <b-list-group-item class="table-file">
                            <b-form-row v-if="item.listAssignments.$model.length==0">
                                <span style=" width: 100%;">There are no assignment records.</span> 
                            </b-form-row>
                            <span v-else>
                                <b-form-row v-for="(itemAssig,index) in item.listAssignments.$model" :key="`assignment-${index}`">
                                <b-col cols="2"><p>{{itemAssig.strSubmittedDateHourShort_EN}}</p></b-col>
                                <b-col cols="1"><p>{{itemAssig.module}}</p></b-col>
                                <b-col cols="1"><p>{{itemAssig.strScore}}</p></b-col>
                                <b-col cols="8" class="comments d-flex justify-content-between" style="padding-right: 30px;">
                                    <v-clamp autoresize :max-lines="1">
                                        {{itemAssig.teacherComments}}
                                       
                                    </v-clamp>
                                      <span class="link blue view-more" @click="directionView(2,itemAssig)">{{ 'View more' }}</span>
                                    <!-- <p>
                                        Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam
                                        nonummy nibh euismod tincidunt ut laoreet dolore...
                                    </p>
                                    <a class="link blue"><span>Download report</span></a> -->
                                </b-col>
                            </b-form-row>
                            </span>
                            
                        </b-list-group-item>
                    </b-list-group>
                    <h6 class="bold" style="font-size: 15px;">Classes:</h6>
                    <b-list-group class="description-list" style="margin-bottom:20px;">
                        <b-list-group-item>
                            <b-form-row >
                                <b-col cols="1" style="padding-left: 30px;"><h6 class="bold">Date</h6></b-col>
                                <b-col cols="2"><h6 class="bold">Start - End</h6></b-col>
                            
                                <b-col cols="4"><h6 class="bold">Topics</h6></b-col>
                                <b-col cols="5"><h6 class="bold">Comments</h6></b-col>
                            </b-form-row>
                        </b-list-group-item>
                        <b-list-group-item class="table-file">
                            <b-form-row v-if="item.listClasses.$model.length==0">
                                <span style=" width: 100%;">There are no class records.</span> 
                            </b-form-row>
                            <span v-else>
                                 <b-form-row v-for="(itemClass,index) in item.listClasses.$model" :key="`classes-${index}`">
                                <b-col cols="1" style="padding-left: 8px;"><p>{{itemClass.dateClassString_EN}}</p></b-col>
                                <b-col cols="2"><p>{{itemClass.scheduleTeacherDetail.strStartEnd}}</p></b-col>
                             
                                <b-col cols="4">
                                    <ul class="list-ul">
                                        <li>{{itemClass.strTopics}}</li>
                                    </ul>
                                </b-col>
                                <b-col cols="5" class="comments d-flex justify-content-between">
                                    <v-clamp autoresize :max-lines="1" style="flex:2">
                                        {{itemClass.comment}}
                                    </v-clamp>
                                     <span class="link blue view-more" @click="directionView(3,itemClass)">{{ 'View more' }}</span>
                                </b-col>
                            </b-form-row>
                                </span>
                           
                        </b-list-group-item>
                    </b-list-group>
                    <h6 class="bold" style="font-size: 15px;">
                    Total hours this month: 
                    <span class="blue">{{item.stringHours.$model}}</span>
                    </h6>
                </div>
             
                <div class="text-center" style="margin-top:52px">
                    <b-button :disabled="$v.dataCourses.$invalid" v-if="$route.params.id == 0 && flagTeacherReport" @click="saveReport(null)"   :class="{ loading: isLoading }" class="btn btn-primary">
                         Save
                    </b-button>
                    <!-- <b-button @click="editComment = !editComment" class="btn btn-primary ml-3">
                        
                        Edit Comment
                    </b-button>-->
                </div>
               
               
                <div class="text-center" style="margin-top:52px" v-if="$route.params.id>0">
                   

                    <span class="desactiveLink ml-3" v-show="buttonPrev==0">
                        <img src="@/assets/icons/icon-arrow-left.svg" class="svg">
                        Previous report
                    </span>
                    <a href="#" v-show="buttonPrev!=0"  class="linkReport mr-3" @click="getReportsPagination(buttonPrev)" >
                        <img src="@/assets/icons/icon-arrow-left.svg" class="svg">
                        Previous report
                    </a>
                    <span class="desactiveLink ml-3" v-show="buttonNext==0">
                        Next report
                        <img src="@/assets/icons/icon-arrow-right.svg" class="svg">
                    </span>
                    <a href="#"   v-show="buttonNext!=0"   class="linkReport ml-3" @click="getReportsPagination(buttonNext)"   >
                        Next report
                        <img src="@/assets/icons/icon-arrow-right.svg" class="svg">
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import * as tools from '@/assets/js/tools.js';
import { baseInstanceAxios } from '@/assets/js/axiosBase.js';
import { validationMessage } from "vuelidate-messages";
import { required } from 'vuelidate/lib/validators'
import { IMAGENES } from '@/assets/js/appConstants'; 

const formMessages = {
	required : function(){ 
        return this.$t('reusables.obligatoryField')},
    isUnique: function(){ 
        return this.$t('reusables.courseAlreadySelected')},
    requiredIf:function(){ 
        return this.$t('reusables.obligatoryField')}
}
export default {
    data(){
        return{
            urlPhoto: IMAGENES.PHOTO_STUDENT_DEFAULT,
            isLoadingDow:false,
            isLoading:false,
            message:null,
            data : null,
            dataStudent : null,
            dataCourses: [],
            editComment : true,
            flagTeacherReport : false,
            buttonPrev : 0,
            buttonNext : 0,
            idParam : false,
            arrayTopic : [{
                description : null,
            }],
        }
    },
     validations : {
        dataCourses : {
            $each: {
                comment : {
                   required 
                },
                subjectName:{},
                stringHours:{},
                flagEdit:{},
                groupRegisterSubjectId:{},
                id:{},
                listEvaluations:{},
                listAssignments:{},
                listClasses:{}
            }
        },
      
    },

    created(){
        console.log("window.location.href.split('?')[0]: ",window.location.href.split('?')[0])
        console.log( location.host)
        if(this.$route.params.flagSearch == undefined){
            this.$router.push({
                    name : 'teacher/student',
                
                }).catch(err => {}); 
        }else{
           
            this.data = this.$route.params
             this.idParam  =  this.data.id != 0 ? true : false
      
            this.flagTeacherReport  =this.$route.params.flagTeacherReport
            this.getData();
        }
    },
    mounted(){
        this.methodSvg();
    },
    methods:{
        directionView(num,item){
            
            switch (num) {
                case 1: case 2:{
                     let data = {
                            id : item.id,
                            flagReport :true,
                            flagTeacherReport : this.flagTeacherReport,
                            type:1
                    }
                    let param = btoa(JSON.stringify(data))
                    window.open(`${location.protocol}//${location.host}/teacher/class/intermediate/${param}`,'_blank')
                    }
                break;
                case 3:{
                    let data = {
                            id: item.scheduleTeacherDetailId , 
                            classId :item.id,
                            flagReport :true,
                            flagTeacherReport : this.flagTeacherReport,
                            type:3
                    }
                    let param = btoa(JSON.stringify(data))
                    window.open(`${location.protocol}//${location.host}/teacher/class/intermediate/${param}`,'_blank')
                }
                break;
            }
        },
        getReportsPagination(id){
            this.data.id = id
  
            this.getData();
            this.methodSvg();
        },
        downloadFile(){
            this.isLoadingDow = true;
            let headers = {
                responseType : "blob"
            }
            baseInstanceAxios.get(
                `${this.apiURL}/resources/PersonsStudentsReports/DownloadFileByReports?id=${this.data.id}&flagTeacher=false&flagLanguage=false&timeZoneName=${this.$store.state.user.timeZoneName}` ,
                headers  )
             .then((response) => {
            
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const today = new Date().toLocaleDateString()
                const now = Date.now()
                const name = `report_${today}_${now}.xlsx`
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${name}.pdf`);
                document.body.appendChild(link);
                link.click();
                this.isLoadingDow = false;
            }).catch(() =>{
               
                this.message = this.$t('error.error-downloading-report');
                this.$bvToast.show("toast-equis-report-student");
                 this.isLoadingDow = false;
            });
            
        },
        saveReport(item){

            this.isLoading = true;

           
            let body = {}

            if(this.data.id==0){
         
                let arrayCourses = this.dataCourses.map(x =>(
                    {
                  
                    GroupRegisterSubjectId :x.groupRegisterSubjectId ,
                    Comment : x.comment
                }))
                body.Id = this.data.id;
                body.UserCreated = this.$store.state.user.email;
                body.ListPersonsStudentsReports = arrayCourses;
                body.PersonsStudentId = this.data.personsStudentId;
                body.PersonTeacherId =this.data.personTeacherId;
                body.Year = this.data.year;
                body.Month = this.data.month;
                body.GroupPlanId = this.data.groupPlanId;
              
                 baseInstanceAxios.post(`${this.apiURL}/resources/PersonsStudentsReports/PersonsStudentsReportsSave`,body)
                .then((response) => {
                    this.data.id=response.data.value;
                    this.idParam  =  this.data.id != 0 ? true : false;
                    let result=response.data.entity.listPersonsStudentsReports;
                    this.message = this.$t('valid.report-successfully-saved');
                    this.$bvToast.show("toast-check-report-student");
                    this.isLoading =false;
                     this.dataCourses.forEach(element => {
                                        element.id= result.find(x=> x.groupRegisterSubjectId == element.groupRegisterSubjectId) !=null ?result.find(x=> x.groupRegisterSubjectId == element.groupRegisterSubjectId).id:0;
                                        element.flagEdit = true;
                                    });
                  /*  setTimeout(() => {
                         this.redireccionarMyStudents();
                    }, 1000);
                 */
                    
                }).catch(() =>{
                    this.isLoading = false;
                    this.message = this.$t('error.error-saving-report');
                    this.$bvToast.show("toast-equis-report-student");
                });
            }else{
                body.Id = item.id.$model;
                body.Comment =item.comment.$model
                body.User = this.$store.state.user.email
             
                baseInstanceAxios.get(`${this.apiURL}/resources/PersonsStudentsReports/PersonStudentReportDetailEditCommentById`,{params : body})
                .then(() => {
                
                    this.message = this.$t('valid.report-successfully-edited');
                    this.$bvToast.show("toast-check-report-student");
                    
                    this.isLoading =false;
                    item.flagEdit.$model = true

                    /*setTimeout(() => {
                        this.$router.push({
                            name : 'teacher/student',
                        }).catch(err => {}); 
                    }, 1000);
                    */

                }).catch(() =>{
                    this.isLoading = false;
                    this.message = this.$t('error.error-editing-report');
                    this.$bvToast.show("toast-equis-report-student");
                });
            }
 
           

        },
        validationMsg: validationMessage(formMessages),
        methodSvg(){
        //importante para los iconos, arriba esta la importación ----------------
            this.$nextTick(function () {
                tools.imgToSvg()
            })
        },
        backStep(){
            this.$router.push({
                name: 'teacher-student-evaluations-reports',
                params: {
                    id: 0,
                    groupId: this.$route.params.groupId,
                    groupPlanId: this.$route.params.groupPlanId,
                    personStudentId: this.$route.params.personStudentId,
                    nameSubject: this.$route.params.nameSubject,
                    flagHistory: this.$route.params.flagHistory,
                    TabClassRequest: this.$route.params.TabClassRequest,
                    typeStudent: this.$route.params.typeStudent,
                }
            });
        },
        redireccionarMyStudents(){
           
           this.$router.push({name : 'teacher/student' , params : 
            { 
                type : this.$route.params.TabClassRequest, 
                typeStudent: this.$route.params.typeStudent
            }})
        },
        getData(){
            this.data.listGroupRegisterSubjectIds = this.data.listGroupRegisterSubjectIds.map(x => (parseInt(x)))
            let body = {
                Id:this.data.id,
                FlagSearch:this.data.flagSearch,
                PersonTeacherId :this.data.personTeacherId,
                PersonsStudentId : this.data.personsStudentId,
                GroupPlanId: this.data.groupPlanId,
                ListGroupRegisterSubjectIds:this.data.listGroupRegisterSubjectIds,
                Year: this.data.year,
                Month: this.data.month,
                TimeZoneName: this.$store.state.user.timeZoneName,
            }
            this.dataCourses = [];
            baseInstanceAxios
            .post(`${this.apiURL}/resources/PersonsStudentsReports/PersonsStudentsReportsById`, body)
            .then(response => {
            
                if(response.data.entity){
                
                    this.dataStudent  = {
                        id : response.data.entity.id,
                        name : response.data.entity.personsStudent.person.strFullName,
                        date :  response.data.entity.strDateMonthReport_EN,
                        groupsCode : response.data.entity.personsStudent.groupsCode,
                        flag : response.data.entity.personsStudent.flagGroup,
                        subjectsStr : this.data.nameCourses
                    }

                    this.buttonPrev = response.data.entity.idPrev;
                    this.buttonNext = response.data.entity.idNext;
                    this.flagTeacherReport = response.data.entity.flagTeacherReport;
                    response.data.entity.listPersonsStudentsReports.forEach(element => {
                    
                        //Evaluations
                        let arrayEvaluations = response.data.entity.listPersonsEvaluations.filter((elementEv) => {
                            return element.groupRegisterSubjectId == elementEv.groupRegisterSubjectId
                        })
                       
                          //Assignments
                        let arrayAssignments =  response.data.entity.listPersonsAssignments.filter((elementEv) => {
                            return element.groupRegisterSubjectId == elementEv.groupRegisterSubjectId
                        })

                          //Classes
                        let arrayClasses =  response.data.entity.listGroupsPlanClass.filter((elementEv) => {
                            return element.groupRegisterSubjectId == elementEv.groupRegisterSubjectId
                        })
                        // Deduplicate by same date+time slot
                        const seenClasses = {};
                        arrayClasses = arrayClasses.filter(c => {
                            const key = `${c.dateClassString_EN}_${c.scheduleTeacherDetail.strStartEnd}`;
                            if (seenClasses[key]) return false;
                            seenClasses[key] = true;
                            return true;
                        });
                        
                      
                        let flagEdit = true;
                        if(this.flagTeacherReport){
                            if(this.data.id==0){
                                flagEdit = false;
                            }
                        }

                        let totalHoursClass = arrayClasses.reduce((acum,curr,currIndex,array)=>{
                            return acum+curr.scheduleTeacherDetail.totalHoursClass
                        },0)
                      
                        let horas   = Math.floor(totalHoursClass);
                        let minutos   = Math.floor((totalHoursClass - horas) * 60);
                   
                        let stringHours = (horas == 0 && minutos > 0) ? `${minutos} minutes`  : (horas == 1 && minutos == 0) ?  `${horas} hours` : (horas == 1 && minutos > 0) ? `${horas} hours ${minutos} minutes` : (horas > 1 && minutos == 0) ? `${horas} hours` : `${horas} hours ${minutos} minutes`;
                            

                      
                        let json = {
                            id : element.id,
                            subjectName:element.subjectName_EN,
                            groupRegisterSubjectId:element.groupRegisterSubjectId,
                            comment : element.comment,
                            flagEdit,
                            listEvaluations : arrayEvaluations,
                            listAssignments : arrayAssignments,
                            listClasses : arrayClasses,
                            stringHours : stringHours
                        }

                        this.dataCourses.push(json)
                  
                    });
                  
                }
                this.methodSvg();
                
            }); 
        }
    }
}
</script>
<style>
.svg{
    fill: #508adf;
    width: 12px;
    margin-left: 12px;
}
.section_gray.text::after{
    content: none;
}

.list-group.description-list .list-group-item:first-child .form-row > [class*=col-]:first-child {
    text-align: initial;
    padding: 0 0 0 18px; 
}
</style>